import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Logger } from '@nsalaun/ng-logger';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Context } from '../../context/models/context.model';
import { DefaultUserTokenClaims } from '../../context/models/user-token-claims.model';
import { ContextService } from '../../context/services/context.service';
import { OauthWrapperService } from '../services/oauth-wrapper.service';

@Injectable({ providedIn: 'root' })
export class InitialAuthenticationGuard<T extends Context, U extends DefaultUserTokenClaims> {
	private contextService = inject<ContextService<T, U>>(ContextService);
	private oauthWrapperService = inject<OauthWrapperService<U>>(OauthWrapperService);
	private logger = inject(Logger);

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.canActivate(route, state);
	}

	canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		this.logger.debug(`[InitialAuthenticationGuard] says called canActivate with url: ${state.url}`);
		return this.contextService.getFirstContext().pipe(
			tap((context: T) =>
				this.logger.debug(`[InitialAuthenticationGuard] says first context has state: ${context.state}, on url: ${state.url}`),
			),
			map((context: T) => !context.isNotLoggedInState()),
			tap((canActivate: boolean) => {
				if (!canActivate) {
					this.logger.debug('[InitialAuthenticationGuard] says start init code flow, to redirect to auth server.');
					this.oauthWrapperService.initCodeFlow(state.url);
				}
			}),
		);
	}
}
